module.exports = __webpack_public_path__ + "img/179994.77ecb47f.png";